/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SurveySections from './survey-sections';
import SurveySectionsDetail from './survey-sections-detail';
import SurveySectionsUpdate from './survey-sections-update';
import SurveySectionsDeleteDialog from './survey-sections-delete-dialog';

const SurveySectionsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SurveySections />} />
    <Route path="new" element={<SurveySectionsUpdate />} />
    <Route path=":id">
      <Route index element={<SurveySectionsDetail />} />
      <Route path="edit" element={<SurveySectionsUpdate />} />
      <Route path="delete" element={<SurveySectionsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SurveySectionsRoutes;
